function ApprochCard({ thumbnail, heading }) {
    return (
        <>
            <div className="col-md-6 col-xl-6 col-12">
                <div className="single-approch-card">
                    <div
                        className="card-thumb bg-contain"
                        style={{
                            backgroundImage: `url(${thumbnail})`,
                        }}
                    />
                    <div className="content">
                        <h3>
                            {heading}
                        </h3>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ApprochCard;
